import React, { PureComponent, Fragment } from 'react';
import Dropzone from 'react-dropzone';
import { Row, Col, Table, Button, Glyphicon } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { post } from 'axios';
import AppConstant, { imageConstants } from '../../../../constants/app';
import InputComponent from '../../../components/baseComponents/input';
import browserImageSize from 'browser-image-size';

class HeaderContentEdit extends PureComponent {
  static propTypes = {
    isActive: PropTypes.bool,
    onClose: PropTypes.func,
    headerData: PropTypes.object,
    items: PropTypes.array,
    addMenuItem: PropTypes.func,
    deleteItem: PropTypes.func,
    hideItem: PropTypes.func,
    onChangeItem: PropTypes.func,
  };

  static defaultProps = {
    items: [],
  };

  state = {
    isImageLoaded: false,
    image: null,
    file: null,
    imageError: null,
    selectedColor: this.props.menuColor
  }

  refFields = {};

  onPreviewDrop = (file) => {
    this.setState({
      isImageLoaded: true,
      file: file[0],
    });
  };

  deleteImage = () => {
    this.setState({
      isImageLoaded: false,
      file: null,
      imageError: '',
    });
  };

  onChange = (e) => {
    this.setState({file:e.target.files[0]})
  }

  removeEmpty = (obj) => {
    Object.keys(obj).forEach((key) => (obj[key] == null) && delete obj[key]);
  }

  isValidForm = () =>
    Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;

  isValidImage = () =>{
    if(this.state.file){
      return browserImageSize(this.state.file).then((dimensions)=>{
        if(dimensions.height > imageConstants.height || dimensions.width > imageConstants.width){
          this.setState({imageError: `Incorrect dimensions (max height: ${imageConstants.height}, max width: ${imageConstants.width})`})
          return false;
        }

        // if(this.state.file.size > imageConstants.size){
        //   this.setState({imageError: `Incorrect size (max size: ${imageConstants.size / 1000000}MB)`})
        //   return false;
        // }

        return true;
      })
    }

    return true;
  }

  onFormSubmit = async(e) => {
    e.preventDefault()

    const validImage = await this.isValidImage();
    this.removeEmpty(this.refFields);
    if(!this.isValidForm()) return false;
    if(!validImage) return false;
    this.uploadItems(this.props.items, this.state.file, this.props.myFiuURL)
      .then(res => {
        this.props.onClickCancelEdit();
        this.props.getHeaderData();

      }).catch(error => {
        console.log(error);
      })
  };

  uploadItems = (items, file, myFiuURL) => {
    const token = localStorage.getItem('token');
    const url = `${AppConstant.API_URL}/header?access_token=${token}`;
    const formData = new FormData();
    let menu_items = items.map((item, index) => ({
        label: item.label,
        url: item.url,
        hidden: item.hidden,
        position: index + 1, 
      }));
    let login_url = myFiuURL;

    if (file) {
      formData.append('file', file)
    }

    formData.append('menu_items', JSON.stringify(menu_items));
    formData.append('login_url', login_url);
    formData.append('menu_color', this.state.selectedColor);
    
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    return post(url, formData, config);
  }

  updateMenuColor = e => {
    const selectedColor = e.target.dataset.color;
    this.setState({ selectedColor });
  }

  render () {
    const {
      onClickCancelEdit,
      addMenuItem,
      deleteItem,
      hideItem,
      onChangeItem,
      onChangeInput,
      items,
      myFiuURL
    } = this.props;

    const {
      isImageLoaded,
      file,
      selectedColor
    } = this.state;

    return (
      <div>
        <h2>Logo</h2>
        <form onSubmit={this.onFormSubmit}>
          <Row>
            <Col sm={8}>
              {
                isImageLoaded
                ? <div className="image-container">
                  <Fragment>
                  {
                    file
                    && <img
                      alt="Preview"
                      key={file.preview}
                      src={file.preview}
                      className="preview-img"
                    />
                  }
                  </Fragment>
                  <Button
                    onClick={this.deleteImage}
                    className="close-btn-dropzone"
                  >
                    <Glyphicon glyph="remove-circle" />
                  </Button>
                </div>
                : <div>
                  <Dropzone
                    className="dropzone in-view"
                    accept="image/*"
                    onDrop={this.onPreviewDrop}
                    multiple={false}
                  >
                    <p>
                      Drag and drop file here
                    </p>
                    <p>or</p>
                    <div className="input-upload">Browse file</div>
                  </Dropzone>
                </div>
              }
              <p className="error-message">{this.state.imageError}</p>
            </Col>
          </Row>

          <h2>MyFIU URL</h2>
          <Row>
            <Col sm={8}>
              <InputComponent
                value={myFiuURL}
                ref={(input) => { this.refFields.login_url = input; }}
                inputGroup="login_url"
                validationRules="required|url"
                customErrorMessage="Required field"
                placeholder='URL'
                classes='form-control'
                onChange={(newValue) => {
                  onChangeInput(newValue, 'myFiuUrl');
                }}
              />
            </Col>
          </Row>

          <h2>Menu color</h2>
          <div className="edit-menu-options">
            <button type="button" data-color="colorDark" onClick={this.updateMenuColor} className={`edit-menu-blue ${selectedColor === 'colorDark' ? 'active' : ''}`}></button>
            <button type="button" data-color="colorLight" onClick={this.updateMenuColor} className={`edit-menu-white ${selectedColor === 'colorLight' ? 'active' : ''}`}></button>
          </div>          
          <h2>Menus</h2>
          <Row>
            <Col sm={8}>
              <Table className="edit-inputs-table">
                <tbody>
                  {items.map((item, index) => (
                    <tr key={`link-item-${item.position}`}>
                      <td>
                        <InputComponent
                          value={"" || item.label}
                          onChange={(newValue, isValid) => {
                            onChangeItem(newValue, 'label', index);
                          }}
                          ref={(input) => { this.refFields['label' + item.position] = input; }}
                          validationRules="required"
                          customErrorMessage="Required field"
                        />
                      </td>
                      <td>
                        <InputComponent
                          value={"" || item.url}
                          onChange={(newValue) => {
                            onChangeItem(newValue, 'url', index);
                          }}
                          ref={(input) => { this.refFields['url' + item.position] = input; }}
                          validationRules="required|url"
                          customErrorMessage="Required field"
                        />
                      </td>
                      <td style={{ minWidth: '125px' }} className="right">
                        <Button
                          style={{ border: 'none' }}
                          onClick={() => {
                            hideItem(index);
                          }}
                        >
                          <Glyphicon
                            glyph={(item.hidden === 0 ? "eye-open" : "eye-close")}
                          />
                        </Button>
                        <Button
                          style={{ border: 'none' }}
                          onClick={() => {
                            deleteItem(item);
                          }}
                        >
                          <Glyphicon glyph="trash" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div
                className="new-menu-link"
                onClick={()=> { addMenuItem() }}
              >
                <Glyphicon glyph="plus" />
                Add item
              </div>
            </Col>
          </Row>
          <Row
            className="buttons-row header-edit-btns">
            <Col sm={8}>
              <Button
                className="cancel-btn"
                onClick={onClickCancelEdit}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="accept-btn"
              >
                Save changes
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

export default HeaderContentEdit;



// WEBPACK FOOTER //
// ./src/app/screens/general/headerContent/headerContentEdit.js